import { ExecutorGroup } from '../../common/model/executor-group';
import { WebUser } from '../../common/model/webUser';
import { SelectionItem } from '../../core/component/select/select.component';
import { ModelBase } from '../../core/model/model-base';
import { Money } from '../../core/model/money';
import { RentalObjectCategory } from '../../rent/model/const/enums';
import { Action } from './action';
import {
  FaultNotificationPriority,
  FaultNotificationPriorityToString,
  FaultNotificationStatus,
  FaultNotificationStatusToString,
} from './const/enum';
import { Resource } from './resource';

export const PrioritySelection = [
  { name: FaultNotificationPriorityToString(FaultNotificationPriority.NotSet), value: FaultNotificationPriority.NotSet },
  { name: FaultNotificationPriorityToString(FaultNotificationPriority.Lowest), value: FaultNotificationPriority.Lowest },
  { name: FaultNotificationPriorityToString(FaultNotificationPriority.Low), value: FaultNotificationPriority.Low },
  { name: FaultNotificationPriorityToString(FaultNotificationPriority.Normal), value: FaultNotificationPriority.Normal },
  { name: FaultNotificationPriorityToString(FaultNotificationPriority.High), value: FaultNotificationPriority.High },
  { name: FaultNotificationPriorityToString(FaultNotificationPriority.Highest), value: FaultNotificationPriority.Highest },
];

export class FaultNotification extends ModelBase {
  constructor() {
    super();
    this.actions = [];
    this.pets = [];
    this.photos = [];

    Object.defineProperties(this, {
      _actions: { enumerable: false, writable: true },
      _createdDate: { enumerable: false, writable: true },
      _closedAt: { enumerable: false, writable: true },
    });
  }

  private _actions: Action[] = [];
  private _createdDate: Date;
  private _closedAt: Date;

  get actions(): Action[] {
    return this._actions;
  }
  set actions(items: Action[]) {
    items.forEach(item => this.addAction(item));
  }
  category: string;
  comment: string;
  get createdDate(): Date {
    return this._createdDate;
  }
  set createdDate(date: Date) {
    this._createdDate = this.coerceDate(date);
  }
  get closedAt(): Date {
    return this._closedAt;
  }
  set closedAt(date: Date) {
    this._closedAt = this.coerceDate(date);
  }

  description: string;
  get firstPartOfDescription(): string {
    if (!this.description || this.description.length <= 33) return this.description;
    return this.description.substr(0, 30) + '...';
  }
  get shortDescription150(): string {
    if (!this.description || this.description.length <= 150) return this.description;
    return this.description.substring(0, 147) + '...';
  }

  get hasPets(): boolean {
    return this.pets && this.pets.length > 0;
  }
  highlight: boolean;
  get isCancelled(): boolean {
    return this.status === FaultNotificationStatus.Cancelled;
  }
  get isResolved(): boolean {
    return this.status === FaultNotificationStatus.Resolved;
  }
  creatorName: string;
  creatorUsername: string;
  number: number;
  pets: string[];
  photos: { src: any; title: string }[];
  priority: FaultNotificationPriority;
  get priorityCaption() {
    return FaultNotificationPriorityToString(this.priority);
  }
  rentalObject: string;
  rentalObjectTypeName: string;
  rentalObjectRentalId: string;
  rentalObjectApartmentNumber: string;
  rentalObjectFloor: number;
  rentalObjectPropertyName: string;
  leaseAgreementPopularName: string;
  dialogEnabled: boolean;
  resource: string;
  resourceName: string;
  resourcesForReporting: Resource[];
  status: FaultNotificationStatus;
  get statusCaption() {
    return FaultNotificationStatusToString(this.status, !this.highlight);
  }
  subcategory: string;
  tenant: string;
  tenantPhone: string;
  tenantEmail: string;
  title: string;
  allowEntranceWithExtraKey: boolean;
  propertyId: string;
  rentalObjectId: string;
  rentalObjectCategory: RentalObjectCategory;
  propertyName: string;
  propertyCostPlace: string;
  dialogId: string | null;
  unreadDialogMessagesCount: number = 0;
  executorWebUser: WebUser;
  executorWebUserId: string;
  executorGroup: ExecutorGroup;
  executorGroupId: string;
  reportingEnabled: boolean;
  referenceName: string;
  isCompany: boolean;
  sendTenantNotification: boolean;
  priceListQuantitySum: number;
  latestAction: string

  get faultNotificationWebUserName() {
    return this.executorWebUser?.personName || this.executorWebUser?.name || '';
  }

  get faultNotificationExecutorGroupName() {
    return this.executorGroup?.name || '';
  }

  addAction(context: any) {
    let action: Action = null;
    if (context instanceof Action) {
      action = context;
    } else {
      action = Object.assign(new Action(), context);
    }
    this._actions.push(action);
  }

  toJSON() {
    const json = Object.assign({}, this);
    json.createdDate = this.clearTimezoneOffset(this.createdDate);
    json.rentalObjectId = this.rentalObjectId;
    json.actions = this.actions;
    return json;
  }

  // Selection items
  resources: SelectionItem[];
  executorGroups: ExecutorGroup[] = [];
  webUsers: WebUser[] = [];
}
